import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Funktionen',
    href: '#funktionen'
  }, {
    name: 'Preise',
    href: '#preise'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'}`} data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="flex justify-between items-center" data-id="element-76">
          <div className="flex-shrink-0" data-id="element-77">
            <a href="#" className="flex items-center" data-id="element-78">
              <img src="https://cdn.magicpatterns.com/uploads/qJp9gXhU3xUHcJ28xJaW9W/logo_voxspace-horizontal.png" alt="vox space Logo" className={`w-[150px] max-w-full h-auto transition-all duration-300 ${isScrolled ? 'brightness-100' : 'brightness-0 invert'}`} data-id="element-79" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-80">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-brand-accent ${isScrolled ? 'text-gray-700' : 'text-gray-200'}`} data-id="element-81">
                {link.name}
              </a>)}
            <a href="#kontakt" className="bg-brand-accent hover:bg-blue-600 text-white px-5 py-2.5 rounded-lg font-medium transition-all transform hover:scale-105 shadow-sm" data-id="element-82">
              Jetzt testen
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-83">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`${isScrolled ? 'text-gray-900' : 'text-white'} focus:outline-none`} data-id="element-84">
              {isMobileMenuOpen ? <X size={24} data-id="element-85" /> : <Menu size={24} data-id="element-86" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white shadow-xl absolute top-full left-0 w-full" data-id="element-87">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-88">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-900 hover:bg-gray-50 rounded-md" data-id="element-89">
                {link.name}
              </a>)}
            <div className="pt-4 px-3" data-id="element-90">
              <a href="#kontakt" onClick={() => setIsMobileMenuOpen(false)} className="block w-full text-center bg-brand-accent text-white px-5 py-3 rounded-lg font-medium" data-id="element-91">
                Jetzt testen
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}